<!--檢查相關資料-->
<div class="page-container">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'appointment-info.title' | translate }}</h2>
  <div class="page-subtitle-block">
      <img
        width="26"
        height="26"
        ngSrc="assets/img/i-light.svg"
        alt="clock-user"
      />
      <div>
        <p class="page-subtitle-block-title">
          {{ 'appointment-info.hint-title' | translate }}
        </p>
        <p [innerHTML]="'appointment-info.hint-message' | translate"></p>
      </div>
      </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!--檢前資料-->
    <div class="card-content register-card-content">
      <h3 class="register-card-title">
        {{ 'appointment-info.pre-exam-info' | translate }}
      </h3>
      @if (noticeSendType === '2') {
      <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title text-gray">
            {{ 'appointment-info.shipping-address' | translate }}
          </p>
          <p>{{ 'appointment-info.pick-up-by-agent' | translate }}</p>
        </div>
      </div>
      }@else if (noticeSendType === '3') {
        <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title text-gray">
            {{ 'appointment-info.shipping-address' | translate }}
          </p>
          <p>{{ 'appointment-info.not-need-to-send' | translate }}</p>
        </div>
      </div>
      }
      <div class="input-block">
        @if (noticeSendType=== '2'|| noticeSendType=== '3') {
        <label class="input-title">{{
          'appointment-info.contact-address' | translate
          }}</label>
        } @else {
        <label class="input-title">{{
          'appointment-info.shipping-address' | translate
          }}</label>
        }
        <div class="input-group">
          <div class="input-address-block">
            <div class="input-address-group">
              <div #fieldRef [attr.data-control-name]="'city'" style="width: 100%">
                <mat-form-field appearance="fill" [ngClass]="{
                    'input-error':
                      showFormError &&
                      (form.get('city')?.invalid ||
                        form.get('district')?.invalid ||
                        form.get('address')?.invalid),
                  }">
                  <mat-select formControlName="city" [placeholder]="'appointment-info.select-city' | translate">
                    @for (city of cities; track city) {
                    <mat-option [value]="city">{{ city }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div #fieldRef [attr.data-control-name]="'district'" style="width: 100%">
                <mat-form-field appearance="fill" [ngClass]="{
                    'input-error':
                      showFormError &&
                      (form.get('city')?.invalid ||
                        form.get('district')?.invalid ||
                        form.get('address')?.invalid),
                  }">
                  <mat-select formControlName="district" [placeholder]="
                      'appointment-info.select-district' | translate
                    ">
                    @for (district of districts; track district) {
                    <mat-option [value]="district">{{ district.areaName }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="input-address-group" #fieldRef [attr.data-control-name]="'address'">
              <input matInput formControlName="address" [placeholder]="
                  'appointment-info.enter-detailed-address' | translate
                " [ngClass]="{
                  'input-error':
                    showFormError &&
                    (form.get('city')?.invalid ||
                      form.get('district')?.invalid ||
                      form.get('address')?.invalid),
                }" />
            </div>
          </div>
          @if (
          showFormError &&
          (form.get('city')?.invalid ||
          form.get('district')?.invalid ||
          form.get('address')?.invalid)
          ) {
          <mat-error class="input-error-msg">{{
            getPreExamAddressErrorMessage()
            }}</mat-error>
          }
        </div>
        
          @if(noticeSendType === '2'||noticeSendType === '3'){
            <div class="input-warn-msg">
              <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
              <span>{{ 'appointment-info.diet-hint' | translate }}</span>
            </div>
          }
      </div>
    </div>

    <!--檢查報告-->
    <div class="card-content register-card-content">
      <h3 class="register-card-title">
        {{ 'appointment-info.exam-report' | translate }}
      </h3>
      @if (reportSendType === '2') {
      <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title text-gray">
            {{ 'appointment-info.delivery-method' | translate }}
          </p>
          <p>{{ 'appointment-info.pick-up-by-agent' | translate }}</p>
        </div>
      </div>
      }@else if (reportSendType === '3'|| reportSendType === '99') {
      <div class="confirm-body">
        <div class="confirm-body-item">
          <p class="confirm-body-item-title text-gray">
            {{ 'appointment-info.delivery-method' | translate }}
          </p>
          <p>{{ 'appointment-info.not-need-to-send' | translate }}</p>
        </div>
      </div>
      } @else {
      <div class="input-block">
        <label class="input-title">{{
          'appointment-info.delivery-method' | translate
          }}</label>
        <div class="input-group" #fieldRef [attr.data-control-name]="'deliveryMethod'">
        <mat-radio-group formControlName="deliveryMethod">
          <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.DOMESTIC.code">{{ 'appointment-info.domestic' |
            translate }}
          </mat-radio-button>
          <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.FOREIGN.code">{{ 'appointment-info.foreign' | translate
            }}
          </mat-radio-button>
        </mat-radio-group>
        @if (showFormError && form.get('deliveryMethod')?.invalid) {
        <mat-error class="input-error-msg">{{
          'error.gender-error.required' | translate
          }}</mat-error>
        }
      </div>
    </div>
    
      @if (
      form.get('deliveryMethod')?.value ===
      API_PARAMS.DELIVERY_METHOD.DOMESTIC.code
      ) {
      <!-- 郵寄國內-->
      <div class="input-block">
        <label class="input-title">{{
          'appointment-info.shipping-address' | translate
          }}</label>
        <section>
          <div class="input-address-block">
            <div class="input-address-group">
              <div #fieldRef [attr.data-control-name]="'reportCity'" style="width: 100%">
                <mat-form-field appearance="fill" [ngClass]="{
                        'input-error':
                          showFormError &&
                          (form.get('reportCity')?.invalid ||
                            form.get('reportDistrict')?.invalid ||
                            form.get('reportAddress')?.invalid),
                      }">
                  <mat-select formControlName="reportCity" [placeholder]="
                          'appointment-info.select-city' | translate
                        " (openedChange)="onInputFocus()">
                    @for (city of cities; track city) {
                    <mat-option [value]="city">{{ city }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div #fieldRef [attr.data-control-name]="'reportDistrict'" style="width: 100%">
                <mat-form-field appearance="fill" [ngClass]="{
                        'input-error':
                          showFormError &&
                          (form.get('reportCity')?.invalid ||
                            form.get('reportDistrict')?.invalid ||
                            form.get('reportAddress')?.invalid),
                      }">
                  <mat-select formControlName="reportDistrict" [placeholder]="
                          'appointment-info.select-district' | translate
                        " (openedChange)="onInputFocus()">
                    @for (district of reportDistricts; track district) {
                    <mat-option [value]="district">{{
                      district.areaName
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="input-address-group">
              <input matInput formControlName="reportAddress" #fieldRef [attr.data-control-name]="'reportAddress'"
                [placeholder]="
                      'appointment-info.enter-detailed-address' | translate
                    " (focus)="onInputFocus()" [ngClass]="{
                      'input-error':
                        showFormError &&
                        (form.get('reportCity')?.invalid ||
                          form.get('reportDistrict')?.invalid ||
                          form.get('reportAddress')?.invalid),
                    }" />
            </div>
          </div>
          @if (
          showFormError &&
          (form.get('reportCity')?.invalid ||
          form.get('reportDistrict')?.invalid ||
          form.get('reportAddress')?.invalid)
          ) {
          <mat-error class="input-error-msg">{{
            getReportAddressErrorMessage()
            }}</mat-error>
          }
        </section>
        <mat-checkbox 
          [checked]="isChecked" 
          [(ngModel)]="isChecked"
          [ngModelOptions]="{standalone: true}"
          (change)="toggleSameAsPreExamInfo($event.checked)" 
          class="address-checkbox">
          {{ 'appointment-info.same-as-pre-exam-info' | translate }}
        </mat-checkbox>
      </div>
      } @else if (
      form.get('deliveryMethod')?.value ===
      API_PARAMS.DELIVERY_METHOD.FOREIGN.code
      ) {
      <!-- 郵寄國外-->
      <div class="input-block">
        <label class="input-title">{{
          'appointment-info.shipping-address' | translate
          }}</label>
        <input matInput formControlName="foreignAddress" #fieldRef [attr.data-control-name]="'foreignAddress'"
          [placeholder]="
                'appointment-info.enter-detailed-address' | translate
              " [ngClass]="{
                'input-error':
                  showFormError && form.get('foreignAddress')?.invalid,
              }" />
        @if (showFormError && form.get('foreignAddress')?.invalid) {
        <mat-error class="input-error-msg">{{
          getForeignAddressErrorMessage()
          }}</mat-error>
        }
      </div>
      }
      
      <!-- 2026/01/27 由PM: 陳亮豪 決定隱藏 -->
      <!-- 收件人資料 -->
      <!-- <div class="input-block" #fieldRef [attr.data-control-name]="'deliveryRecipient'">
        <label class="input-title" >{{
          'appointment-info.report-recipient-info' | translate
          }}</label>
        <mat-radio-group formControlName="deliveryRecipient">
          <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.SELF.code">{{
            'appointment-info.report-recipient-self' |
            translate }}
          </mat-radio-button>
          <mat-radio-button [value]="API_PARAMS.DELIVERY_METHOD.NOT_SELF.code">{{
            'appointment-info.report-recipient-notSelf' | translate
            }}
          </mat-radio-button>
         
          @if (showFormError && form.get('deliveryRecipient')?.invalid) {
          <mat-error class="input-error-msg">{{
            'error.gender-error.required' | translate
            }}</mat-error>
          }
        </mat-radio-group>
      </div> -->
      <!-- 收件人姓名 -->
       @if(form.get('deliveryRecipient')?.value === API_PARAMS.DELIVERY_METHOD.NOT_SELF.code){
      <div class="input-block">
            <label class="input-title">{{
              'appointment-info.report-recipient-name' | translate
              }}</label>
            <input matInput formControlName="recipient" #fieldRef [attr.data-control-name]="'recipient'" [placeholder]="
                    'appointment-info.report-recipient-name' | translate
                  " [ngClass]="{
                    'input-error':
                      showFormError && form.get('recipient')?.invalid,
                  }" />
            @if (showFormError && form.get('recipient')?.invalid) {
            <mat-error class="input-error-msg">{{
              'error.delivery-recipient-error.required' | translate
              }}</mat-error>
            }
          
      </div>
        }
      <!-- 收件人電話 -->
       @if(form.get('deliveryRecipient')?.value === API_PARAMS.DELIVERY_METHOD.NOT_SELF.code){
      <div class="input-block">
            <label class="input-title">{{
              'appointment-info.report-recipient-cell' | translate
              }}</label>
            <input matInput formControlName="recipientCell" #fieldRef [attr.data-control-name]="'recipientCell'"
              [placeholder]="
                    'appointment-info.report-recipient-cell' | translate
                  " [ngClass]="{
                    'input-error':
                      showFormError && form.get('recipientCell')?.invalid,
                  }" />
            @if (showFormError && form.get('recipientCell')?.invalid) {
            <mat-error class="input-error-msg">
              @if (form.get('recipientCell')?.errors?.['required']) {
              {{ 'error.phone-error.required' | translate }}
              }
              @if (form.get('recipientCell')?.errors?.['invalidFormat']) {
              {{ form.get('recipientCell')?.errors?.['invalidFormat'] }}
              }
            </mat-error>
            }
      </div> 
        }
      }
      <!-- 報告語言 -->
      <div class="input-block">
        <label class="input-title">{{
          'appointment-info.report-language' | translate
          }}</label>
       <div class="input-group" #fieldRef [attr.data-control-name]="'language'">
        <mat-radio-group formControlName="language">
          @for (language of languages; track language.uno) {
          <mat-radio-button [value]="language.uno">
            {{ language.noDesc }}
            @if (
            language.uno === API_PARAMS.EXAM_REPORT_LANGUAGE.JAPANESE.code
            ) {
            <span>
              ({{
              'appointment-info.addition-translate-fee' | translate
              }})</span>
            }
          </mat-radio-button>
          }
        </mat-radio-group>
        @if (showFormError && form.get('language')?.invalid) {
        <mat-error class="input-error-msg">{{
          'error.language-error.required' | translate
          }}</mat-error>
        }
        </div>
      </div>
    </div>

    <!--健檢服-->
    <div class="card-content register-card-content">
      <h3 class="register-card-title">
        {{ 'appointment-info.checkup-clothing' | translate }}
      </h3>
      <div class="input-block">
        <label class="input-title">{{
          'appointment-info.select-size' | translate
          }}</label>
        <div class="input-group" #fieldRef [attr.data-control-name]="'clothSize'">
          <mat-radio-group formControlName="clothSize">
            @for (size of clothesSizes; track size.uno) {
            <mat-radio-button [value]="size.uno">{{
              size.noDesc
              }}</mat-radio-button>
            }
          </mat-radio-group>
          @if (showFormError && form.get('clothSize')?.invalid) {
          <mat-error class="input-error-msg">{{
            'error.size-error.required' | translate
            }}</mat-error>
          }
        </div>
      </div>
      @if (
      sharedStorageService.get('userPlanRequest')?.gender ===
      API_PARAMS.GENDER.MALE
      ) {
      <div class="input-block">
        <div class="input-cloth-group">
          <img class="img-cloth" width="200" src="assets/img/img-male-cloth.png" alt="" />
          <img width="295" src="assets/img/img-male-cloth-size.png" alt="" />
        </div>
        <div class="input-cloth-group">
          <img class="img-cloth" width="200" src="assets/img/img-pants-l.png" alt="" />
          <img width="295" src="assets/img/img-male-pants-size.png" alt="" />
        </div>
      </div>
      <div class="input-block">
        <div class="input-cloth-group">
          <img class="img-size-recommand-l" width="530" src="assets/img/img-male-size-recommand-l.png" alt="" />
          <img class="img-size-recommand-s" width="590" src="assets/img/img-male-size-recommand-s.png" alt="" />
        </div>
      </div>
      } @else {
      <div class="input-block">
        <div class="input-cloth-group">
          <img class="img-cloth" width="200" src="assets/img/img-female-cloth.png" alt="" />
          <img width="295" src="assets/img/img-female-cloth-size.png" alt="" />
        </div>
        <div class="input-cloth-group">
          <img class="img-cloth" width="200" src="assets/img/img-pants-l.png" alt="" />
          <img width="295" src="assets/img/img-female-pants-size.png" alt="" />
        </div>
      </div>
      <div class="input-block">
        <div class="input-cloth-group">
          <img class="img-size-recommand-l" width="530" src="assets/img/img-female-size-recommand-l.png" alt="" />
          <img class="img-size-recommand-s" width="590" src="assets/img/img-female-size-recommand-s.png" alt="" />
        </div>
      </div>
      }
    </div>

    <!--檢查當日餐食-->
    <div class="card-content register-card-content">
      <h3 class="register-card-title">
        {{ 'appointment-info.checkup-diet' | translate }}
      </h3>
      <div class="input-block">
        <label class="input-title">{{
          'appointment-info.select-diet' | translate
          }}</label>
        <div class="input-group">
          <div class="input-diet-block">
            <div class="input-diet-group" #fieldRef [attr.data-control-name]="'breakfast'">
              <mat-form-field appearance="fill" [ngClass]="{
                  'input-error':
                    showFormError &&
                    (form.get('breakfast')?.invalid ||
                      form.get('lunch')?.invalid),
                }">
                <mat-select formControlName="breakfast" [placeholder]="
                    'appointment-info.select-breakfast' | translate
                  ">
                  @for (breakfast of breakfasts; track breakfast.uno) {
                  <mat-option [value]="breakfast.uno">{{
                    breakfast.noDesc
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if(lunches.length > 0){
            <div class="input-diet-group" #fieldRef [attr.data-control-name]="'lunch'">
              <mat-form-field appearance="fill" [ngClass]="{
                  'input-error':
                    showFormError &&
                    (form.get('breakfast')?.invalid ||
                      form.get('lunch')?.invalid),
                }">
                <mat-select formControlName="lunch" [placeholder]="'appointment-info.select-lunch' | translate">
                  @for (lunch of lunches; track lunch.uno) {
                  <mat-option [value]="lunch.uno">{{
                    lunch.noDesc
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            }
          </div>
          @if (
          showFormError &&
          (form.get('breakfast')?.invalid || form.get('lunch')?.invalid)
          ) {
          <mat-error class="input-error-msg">{{
            getDietErrorMessage()
            }}</mat-error>
          }
        </div>
        <div class="input-warn-msg">
          <img width="16" height="16" ngSrc="/assets/img/i-warn-outline.svg" alt="" />
          <span>{{ 'appointment-info.diet-hint' | translate }}</span>
        </div>
      </div>
    </div>

    <!--固定按鈕區塊-->
    <div class="page-btn-block">
      <button mat-button type="submit" class="btn-fill-primary btn-size-l">
        {{ 'common.button.next' | translate }}
      </button>
    </div>
  </form>

</div>
